"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C1.46957 0 0.960859 0.210714 0.585787 0.585787C0.210714 0.960859 0 1.46957 0 2V10C0 10.5304 0.210714 11.0391 0.585787 11.4142C0.960859 11.7893 1.46957 12 2 12H9.33333C9.51014 12 9.67971 11.9298 9.80474 11.8047C9.92976 11.6797 10 11.5101 10 11.3333C10 11.1565 9.92976 10.987 9.80474 10.8619C9.67971 10.7369 9.51014 10.6667 9.33333 10.6667H2C1.82319 10.6667 1.65362 10.5964 1.5286 10.4714C1.40357 10.3464 1.33333 10.1768 1.33333 10V2C1.33333 1.82319 1.40357 1.65362 1.5286 1.5286C1.65362 1.40357 1.82319 1.33333 2 1.33333H9.33333C9.51014 1.33333 9.67971 1.2631 9.80474 1.13807C9.92976 1.01305 10 0.843478 10 0.666667C10 0.489856 9.92976 0.320286 9.80474 0.195262C9.67971 0.0702379 9.51014 0 9.33333 0H2ZM8.47133 2.862C8.40984 2.79833 8.33627 2.74754 8.25494 2.7126C8.1736 2.67766 8.08612 2.65927 7.9976 2.6585C7.90908 2.65773 7.8213 2.6746 7.73936 2.70812C7.65743 2.74164 7.583 2.79114 7.5204 2.85374C7.45781 2.91633 7.40831 2.99077 7.37479 3.0727C7.34127 3.15463 7.3244 3.24241 7.32517 3.33093C7.32594 3.41945 7.34433 3.50693 7.37927 3.58827C7.41421 3.66961 7.46499 3.74317 7.52867 3.80467L9.05733 5.33333H3.33333C3.15652 5.33333 2.98695 5.40357 2.86193 5.5286C2.7369 5.65362 2.66667 5.82319 2.66667 6C2.66667 6.17681 2.7369 6.34638 2.86193 6.4714C2.98695 6.59643 3.15652 6.66667 3.33333 6.66667H9.05733L7.52867 8.19533C7.40723 8.32107 7.34003 8.48947 7.34155 8.66427C7.34307 8.83907 7.41318 9.00627 7.53679 9.12988C7.66039 9.25348 7.8276 9.3236 8.0024 9.32512C8.1772 9.32664 8.3456 9.25944 8.47133 9.138L11.138 6.47133C11.263 6.34631 11.3332 6.17678 11.3332 6C11.3332 5.82322 11.263 5.65369 11.138 5.52867L8.47133 2.862Z",
    fill: fill
  }));
};

exports["default"] = _default;